import React from 'react';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Strings from '../../common/Strings';
import './PlanAndBilling.css';
import '../Common.css';
import { isCardExpiring } from '../../helpers/card';
import { failedPayment } from '../../helpers/payment';
import PlanAndBillingPlan from './PlanAndBillingPlan';
import PlanAndBillingUsage from './PlanAndBillingUsage';
import PlanAndBillingBillingInformation from './PlanAndBillingBillingInformation';
import PlanAndBillingHistory from './PlanAndBillingHistory';

const moment = require('moment');

class PlanAndBilling extends React.Component {
  renderExpiringNotification() {
    const ExpiringNotification = this.props.paymentCardExpiring ? (
      <div className="plan-and-billing-expiring-notification-with-icon">
        <Image
          className="plan-and-billing-icon-alert"
          src="/error/icon_banner_alert.png"
        />
        <p className="plan-and-billing-warning">
          <p style={{ fontSize: '1.15em' }}>
            <b>{Strings.BILLING.cardExpiring1}</b>
          </p>{' '}
          <p>
            {Strings.BILLING.cardExpiring2}{' '}
            <b>{Strings.BILLING.cardExpiring3}</b>
          </p>
        </p>
      </div>
    ) : (
      ''
    );

    return <React.Fragment>{ExpiringNotification}</React.Fragment>;
  }

  renderFailedPaymentNotification() {
    const { paymentHistory } = this.props;

    const PlanBillingError = this.props.paymentHistoryFailedPayment ? (
      <div className="plan-and-billing-expiring-notification-with-icon">
        <Image
          className="plan-and-billing-icon-alert"
          src="/error/icon_banner_alert.png"
        />
        <p className="plan-and-billing-warning">
          {Strings.BILLING.failedPayment1}{' '}
          {moment(paymentHistory.values().next().value.date).format(
            'MMM D, YYYY',
          )}{' '}
          {Strings.BILLING.failedPayment2}
        </p>
      </div>
    ) : (
      ''
    );

    return <React.Fragment>{PlanBillingError}</React.Fragment>;
  }

  renderNoCardNotification() {
    const NoCardNotification =
      !this.props.paymentCardLoading &&
      !this.props.paymentCard &&
      this.props.subscription.status === 'active' &&
      !this.props.subscription.cancelAtPeriodEnd ? (
        <div className="plan-and-billing-expiring-notification-with-icon">
          <Image
            className="plan-and-billing-icon-alert"
            src="/error/icon_banner_alert.png"
          />
          <p className="plan-and-billing-warning">{Strings.BILLING.noCard}</p>
        </div>
      ) : (
        ''
      );

    return <React.Fragment>{NoCardNotification}</React.Fragment>;
  }

  render() {
    return (
      <div className="plan-and-billing-content">
        {this.renderFailedPaymentNotification()}
        {this.renderExpiringNotification()}
        {this.renderNoCardNotification()}
        <PlanAndBillingPlan />
        <PlanAndBillingUsage />
        <PlanAndBillingBillingInformation />
        <PlanAndBillingHistory />
      </div>
    );
  }
}

PlanAndBilling.defaultProps = {
  paymentCard: null,
};

PlanAndBilling.propTypes = {
  paymentCard: PropTypes.shape({}),
  paymentCardLoading: PropTypes.bool.isRequired,
  paymentCardExpiring: PropTypes.bool.isRequired,
  paymentHistory: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.number.isRequired,
    }),
  ).isRequired,
  paymentHistoryFailedPayment: PropTypes.bool.isRequired,
  subscription: PropTypes.shape({
    status: PropTypes.string.isRequired,
    cancelAtPeriodEnd: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = state => ({
  paymentCard: state.paymentCards.card,
  paymentCardLoading: state.paymentCards.loading,
  paymentCardExpiring: isCardExpiring(
    state.paymentCards.card,
    state.upcomingInvoice.upcoming,
  ),
  paymentHistory: state.paymentHistory.items,
  paymentHistoryLoading: state.paymentHistory.loading,
  paymentHistoryFailed: state.paymentHistory.failed,
  paymentHistoryFailedPayment: failedPayment(state.paymentHistory.items),
  subscription: state.premiumSubscription.subscription,
});

export default connect(mapStateToProps)(PlanAndBilling);



// WEBPACK FOOTER //
// ./src/components/settings/PlanAndBilling.js